var _style, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1366 768",
    style: {
      enableBackground: "new 0 0 1366 768"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M568,234c-4.5-6.3-9.5-12.3-14.9-17.8c-43.4-44.1-103.7-71.5-170.3-71.5c-132.4,0-240,108.2-238.9,240.9 c1,128.6,105.1,234.1,233.6,236.8c64.3,1.4,123.1-22.8,166.9-63.1c0,0-32.1-0.5-43.7-24.6l0,0c-32.5,25.4-73.5,40.6-117.9,40.6 c-108.3,0-195.9-90.2-191.7-199.4c3.9-100.9,86.7-182.1,187.7-184.2c60.1-1.2,114.2,25.4,150.1,67.8l3,4.1l39.8-24.5L568,234z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.6,278.4C441.9,333.2,398.2,387,375.2,431.9l-69.4-120.2c-10-17.2-32-23.2-49.3-13.2l-25.4,17l83.8,145.1 c16.3,28.3,39,52.4,66.1,70.5c8.8,5.9,15.5,10.3,15.5,10.3s90.1-265.5,341.4-340.3c0,0,51.2-14.9,96.4-19.4 C834.3,181.6,651.1,161.5,508.6,278.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M648.5,456.7c10.2-7.5,15.3-20.2,15.3-38.1c0-16.7-2.5-29.6-7.4-38.8c-4.9-9.1-12.7-15.5-23.5-19.2 c-10.8-3.7-25.5-5.5-44.2-5.5c-21,0-37.3,2.7-48.9,8.2c-11.5,5.5-19.8,15-24.9,28.6c-5,13.6-7.5,33-7.5,58.1 c0,24.5,2.7,43.4,8.1,56.9c5.4,13.5,14,23,25.9,28.5c11.9,5.5,28.2,8.2,49,8.2c13,0,24.5-0.7,34.3-2.1c9.8-1.4,20.8-3.3,32.9-5.8 v-29.8h-53.8c-12.3,0-21.7-1.2-28.1-3.6c-6.4-2.4-10.9-6.3-13.4-11.7c-2.5-5.4-4-13-4.5-22.8h46.3 C623.5,468,638.3,464.2,648.5,456.7z M557.1,437.8c0-12.1,1-21.5,3.1-28.1c2.1-6.6,5.3-11.3,9.8-13.9c4.5-2.6,10.7-3.9,18.7-3.9 c11,0,18.7,2,23.3,6c4.6,4,6.9,11,6.9,21.1c0,6.9-1.5,11.7-4.6,14.6c-3.1,2.9-8.2,4.3-15.3,4.3H557.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M763.2,363.6c-8.3,5.4-16.2,12.9-23.5,22.5h0c-7.1-17-23.7-28.1-42.1-28.1h-8.7v184.1h50.8V427.5 c6.4-6.9,13.1-11.9,20.2-15.1c7.1-3.2,15.5-4.8,25.4-4.8c2.5,0,9.7,0.6,21.6,1.7v-52.1c-4.1-1.1-9.1-1.7-15.1-1.7 C781,355.5,771.5,358.2,763.2,363.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M871.2,283.2h-39.1c-4.8,0-7.2,2.4-7.2,7.2V324c0,2.1,0.6,3.7,1.9,5c1.3,1.3,3,1.9,5.3,1.9h39.1 c4.3,0,6.5-2.3,6.5-6.9v-33.6c0-2.1-0.6-3.8-1.7-5.1C874.8,283.9,873.2,283.2,871.2,283.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 825.9,
    y: 357.9,
    className: "st0",
    width: 50.8,
    height: 184.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1121.3,357.9L1088,500.6c-4.1-0.5-8-1.7-11.7-3.8c-3.7-2.1-6.4-6.9-8.2-14.4L1039,357.9h-20.9h-32h-14.7 v-15.1c0-8.2,1.4-14.1,4.3-17.7c2.9-3.5,8.2-5.3,15.9-5.3h28.1v-36.4c-12.3-3.4-25-5.1-38.1-5.1c-21.7,0-37.4,5.3-47,15.9 c-9.6,10.6-14.4,27.7-14.4,51.3v12.3l-26.1,8.2v32.6h26.1v143.3h51.1V398.7h25.2l24.1,94c8.5,32.9,27.9,49.4,58.3,49.4l-19.9,81.3 h42.2l16.5-33.9l54.9-231.5H1121.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logoHeader.2157878addc805c38a1897e8af436c21.svg";
export { ForwardRef as ReactComponent };